$(function() {
  var domain = "py3-api.citiesocial.com";
  var collection_api = "//" + domain + "/early-bird/collection/";

  $.get(collection_api, function(result) {
    // get main project
    var mainData = result.find(function(item) {
      return item.is_main_in_collection;
    });

    // 早鳥頁面將淘汰，不會有主打專案，先 hard code 隱藏
    // mainProject(mainData);

    // get all other projects
    const endProjects = $.grep(result, function(n) {
      return (
        !n.is_main_in_collection &&
        new Date().getTime() > new Date(n.deadline).getTime()
      );
    });

    var gridProjects = $.grep(result, function(n) {
      return (
        !n.is_main_in_collection &&
        new Date().getTime() < new Date(n.deadline).getTime()
      );
    });

    gridProjects = [...gridProjects, ...endProjects];

    $.each(gridProjects, function(i, project) {
      updateInfo(project.shopify_product_id, project);
    });

    $("#loading-overlay").hide();
  });

  $(document).on("click", ".coming-title", function() {
    Object.assign(document.createElement("a"), {
      target: "_blank",
      href: $(this).data("url")
    }).click();
  });

  // 主打專案更新
  function mainProject(data) {
    if (data !== undefined) {
      $(".main-product-img img")
        .attr("src", data.image)
        .show();
      $(".main-product-img img").click(function() {
        $("[data-sf-id='" + data.shopify_product_id + "'] a")[0].click();
      });

      $(".info-count-down").html("倒數" + countDays(data.deadline) + "天");

      updateState(".main-product-info", "info", data);

      $(".info-brand").html("品牌：" + data.brand_name);
      $(".info-title").html(data.name);

      $(".info-summary").html(linkString(35, data.promotion_text) + "...");

      updateOrdered(".main-product-info", "info", data);

      $(".btn-mod").click(function() {
        $("[data-sf-id='" + data.shopify_product_id + "'] a")[0].click();
      });
    } else {
      $(".main-product").hide();
    }
  }

  // 九宮格專案更新
  function updateInfo(shopifyId, data) {
    var mainSelector = "[data-sf-id='" + shopifyId + "']";
    var $projectBlock = $(mainSelector);
    // 圖片
    $projectBlock.find(".project-img").attr("src", data.image);

    $projectBlock.show();
    var available = Date.parse(data.available_at);
    var deadline = Date.parse(data.deadline);

    if (deadline < Date.now()) {
      // 已經結束
      const $img = $projectBlock.find(".project-img");
      $img.addClass("coming");

      var finishText = $("<div></div>")
        .addClass("coming-title")
        .html("早鳥首賣成功")
        .data("url", data.shopify_url);

      $img.after(finishText);
      $img.parent().addClass("coming");

      $projectBlock.find(".project-status").remove();
      $projectBlock.find(".project-brand").remove();

      $("<div></div>")
        .addClass("coming-label")
        .html("專案已結束")
        .appendTo($projectBlock);
      $projectBlock
        .find(".project-title")
        .first()
        .appendTo($projectBlock);

      $projectBlock.find(".project-line").remove();
      $projectBlock.find(".info-ordered").remove();

      $projectBlock.appendTo("#main-grid");
    } else if (available < Date.now()) {
      // 已經開賣
      // 專案狀態
      updateState(mainSelector, "project", data);
      // 倒數天數
      var $countdown = $projectBlock.find(".project-status .project-countdown");
      $countdown.html("倒數" + countDays(data.deadline) + "天");
      // 品牌
      var $brand = $projectBlock.find(".project-brand");
      $brand.html("品牌：" + data.brand_name);
      // 產品名稱
      var $title = $projectBlock.find(".project-line .project-title");
      $title.html(data.name);

      updateOrdered(mainSelector, "project", data);
    } else {
      $projectBlock.find(".project-img").addClass("coming");
      var icon = $("<i></i>").addClass("cs_icon icon-arrowRight coming-icon");
      var sub = $("<div></div>")
        .addClass("coming-sub")
        .html("填問卷搶先看 ")
        .append(icon);
      var comingText = $("<div></div>")
        .addClass("coming-title")
        .html("COMING SOON")
        .data("url", data.questionnaire_url)
        .append(sub);

      $projectBlock
        .find("a")
        .addClass("coming")
        .attr("target", "_blank")
        .attr("href", data.questionnaire_url)
        .append(comingText);

      $projectBlock.find(".project-status").remove();
      $projectBlock.find(".project-brand").remove();

      $("<div></div>")
        .addClass("coming-label")
        .html("即將上線")
        .appendTo($projectBlock);
      $projectBlock
        .find(".project-title")
        .first()
        .appendTo($projectBlock);
      $projectBlock.find(".project-line").remove();
      $projectBlock.find(".info-ordered").remove();

      $projectBlock.appendTo("#main-grid");
    }
  }

  function updateState(mainSelector, blockSelector, data) {
    var $projectBlock = $(mainSelector);

    var $state = $projectBlock.find(
      "." + blockSelector + "-status .state-label"
    );

    var stateClass = "limit";
    var stateText = "限量";

    var stateData = {
      is_extreme_early_bird: false,
      amount: 0
    };
    if (data.inventory_quantity_status !== null) {
      stateData = data.inventory_quantity_status;
    }
    if (stateData.is_extreme_early_bird) {
      stateClass = "early";
      stateText = "超早鳥優惠";
    }
    // 專案狀態
    $state.addClass(stateClass + "-border " + stateClass + "-color");
    $state.html(stateText);
    // 專案剩餘數量
    var $left = $projectBlock.find("." + blockSelector + "-status .left-count");
    $left.html("剩餘" + stateData.amount + "組");
    $left.addClass(stateClass + "-color");
  }

  function updateOrdered(mainSelector, blockSelector, data) {
    var $projectBlock = $(mainSelector);
    // Hot
    if (data.is_hot && Date.parse(data.deadline) > Date.now()) {
      $projectBlock.find("." + blockSelector + "-ordered .hot-label").show();
    }
    // 預購人數
    var $people = $projectBlock.find("." + blockSelector + "-ordered .people");
    $people.html(formatNumber(data.order_count));
    // 累積金額
    var $amount = $projectBlock.find("." + blockSelector + "-ordered .amount");
    $amount.html("NT$ " + formatNumber(data.total_amount));
  }

  function countDays(deadline) {
    var deadlineDate = new Date(deadline);
    var currentDate = new Date();
    var DifferenceInTime = deadlineDate.getTime() - currentDate.getTime();
    var DifferenceInDays = DifferenceInTime / (1000 * 3600 * 24);
    return Math.round(DifferenceInDays);
  }

  function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  function linkString(max, text) {
    if (text.length > max) {
      return text.substr(0, max);
    } else {
      return text;
    }
  }
});
